import { NativeSearchAnalyticsInput } from '~/core/configuration/configuration.type';

export const nativeSearchInput = (
    config: NativeSearchAnalyticsInput,
    sendEventToGA: (searchTerm: string) => Promise<boolean>
): void => {
    const { nativeInput } = config;
    const { selectors, event } = nativeInput;

    selectors.forEach((selector) => {
        const elements = document.querySelectorAll(selector);

        elements.forEach((element) => {
            element.addEventListener(
                event,
                (e) => {
                    const target = e.target as HTMLInputElement;
                    const value = target.value;
                    console.log('native search input event', value);
                    sendEventToGA(value);
                },
                { capture: true }
            );
        });
    });
};
